import { apiClient } from 'api/APIClient';
import { entityAPI, getPathwayData } from 'api/GenericAPI';
import { nodeAPI, edgeAPI } from 'api/GenericPathwayAPI';
import { transformCampaignPathwayToFlow } from 'api/Campaigns/CampaignTransformers';

import {
  Campaign,
  Campaign_Node_Backend,
  Campaign_Pathway_Backend,
  CampaignPathwayFlow,
} from 'api/Campaigns/CampaignInterfaces';

import {
  Edge_Base_Backend,
  Node_Type,
  Functionality_Base_Backend,
  Functionality_Value_Base_Backend,
} from 'api/GenericPathwayInterfaces';

import { Person, Address } from 'api/Community/CommunityInterfaces';

// ===================================================
// 🔹 Campaign CRUD API
// ===================================================
export const campaignAPI = entityAPI<Campaign>('campaigns', 'campaigns');
export const nodeTypesAPI = entityAPI<Node_Type>('campaigns', 'node_types');
export const functionalityAPI = entityAPI<Functionality_Base_Backend>(
  'campaigns',
  'functionalities',
);
export const functionalityValuesAPI = entityAPI<Functionality_Value_Base_Backend>(
  'campaigns',
  'functionality_values',
);

// ===================================================
// 🔹 Custom Endpoints
// ===================================================

/** Fetch standardized pathway data (summary + nodes + edges) */
export const getCampaignPathwayData = async (id: string): Promise<CampaignPathwayFlow> => {
  return getPathwayData<Campaign_Pathway_Backend, CampaignPathwayFlow>(
    `/campaigns/${id}/campaign_pathway/`,
    transformCampaignPathwayToFlow,
  );
};

export const campaignNodeAPI = nodeAPI<Campaign_Node_Backend>('campaigns');
export const campaignEdgeAPI = edgeAPI<Edge_Base_Backend>('campaigns');

/** Get all people in a specific campaign node */
export const getNodePeople = async (nodeId: number): Promise<Person[]> => {
  const { data } = await apiClient.get<Person[]>(`/campaigns/nodes/${nodeId}/people/`);
  return data;
};

/** Get all people in a specific campaign node */
export const getNodeAddresses = async (nodeId: number): Promise<Address[]> => {
  const { data } = await apiClient.get<Address[]>(`/campaigns/nodes/${nodeId}/addresses/`);
  return data;
};



/** Move selected people from one node to another */
export const moveItemsBetweenNodes = async (params: {
  node_id?: number;
  item_field_name: string;          // "people" | "addresses" | etc
  selected_items: number[];         // ids only
  handle_name: string;              // functionality id
  direction: "forward" | "backward";
  interaction_id?: number;
  interaction_type?: string;
}): Promise<any> => {
  const { data } = await apiClient.post(
    `/campaigns/move_items_between_nodes/`,
    params,
  );
  return data;
};


/** Add Items to a Node */
export const addItemsToNodes = async (params: {
  node_id?: number;
  item_field_name: string;          // "people" | "addresses" | etc
  selected_items: number[];         // ids only
  interaction_id?: number;
  interaction_type?: string;
  selected_items_input?: any[];         // for input of new items (e.g. people with first_name, last_name, email)
}): Promise<any> => {
  const { data } = await apiClient.post(
    `/campaigns/add_items_to_nodes/`,
    params,
  );
  return data;
};

